var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275,
    y: 0.275,
    width: 21.45,
    height: 21.45,
    rx: 10.725,
    stroke: "#43419E",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2p93xaj40a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#99l9x8aneb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.174 9.806 14.472 7.08a1.032 1.032 0 0 0-.875-.485H4.333c-.57 0-1.032.462-1.032 1.032v5.802c0 .57.462 1.033 1.032 1.033h.271c.26.556.823.946 1.477.946.655 0 1.217-.39 1.477-.946h6.886c.26.556.822.946 1.477.946.654 0 1.216-.39 1.477-.946h.27c.57 0 1.033-.463 1.033-1.033v-.859a2.78 2.78 0 0 0-2.527-2.763zM6.084 14.45a.676.676 0 1 1 0-1.352.676.676 0 0 1 0 1.352zm6.179-3.921V7.627h1.334l1.811 2.9h-3.145zm3.658 3.92a.676.676 0 1 1 0-1.35.676.676 0 0 1 0 1.35z",
    fill: "#43419E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2p93xaj40a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 3.3)",
    d: "M0 0h15.4v15.4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "99l9x8aneb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 3.3)",
    d: "M0 0h15.4v15.4H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanIcon);
export default __webpack_public_path__ + "static/media/van-icon.d4f6e914.svg";
export { ForwardRef as ReactComponent };